import {
  Button,
  Dialog,
  Paper,
  Grid,
  IconButton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  tableCellClasses,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Chip,
  Divider,
  Switch,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Container } from 'reactstrap';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import axios from '../../utils/axios';
import UIContext from '../../context/UIContext';

const StyledTableCell = styled(TableCell)({
  color: 'white !important',
  border: 'solid 1px #dee2e6',
  fontWeight: '800',
  textAlign: 'center',
  backgroundColor: '#2A4759',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const filterInitialValue = {
  searchTerm: '',
  Active: true,
};

const User = () => {
  const userInitailValue = useMemo(
    () => ({
      UserID: 0,
      LoginCode: '',
      LoginName: '',
      Password: '',
      EmailId: '',
      DesignationID: null,
      SupervisorIds: [],
      Active: 'yes',
    }),
    []
  );

  const [filterData, setFilterData] = useState(filterInitialValue);
  const [userTableData, setUserTableData] = useState([]);
  const [user, setUsers] = useState([]);
  const [userList, setUserList] = useState([]);
  const [designationData, setDesignationData] = useState([]);
  const [initialValue, setInitialValue] = useState(userInitailValue);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [OpType, setOpType] = useState('New');
  const [deleteUser, setDeleteUser] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [LoginUserId, setLoginUserId] = useState(null);

  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  // api fetch data
  useEffect(() => {
    const UserId = sessionStorage.getItem('UserId');
    setLoginUserId(UserId);
    getAllUser();
    getAllHelpData();
  }, []);

  async function getAllUser() {
    try {
      showLoading();
      const response = await axios.get('master/user/GetAllUser');
      setUsers(response.data);
      setUserList(response.data.filter((user) => user.Active === 'yes'));
    } catch (e) {
      openSnackBar(e.response?.data || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const getAllHelpData = async () => {
    try {
      const desigs = await axios.get('master/Designation/GetAllDesignation');
      setDesignationData(desigs.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
  };

  const userValidationSchema = useMemo(
    () =>
      Yup.object().shape({
        LoginCode: Yup.string()
          .trim()
          .min(2, ({ min }) => `Minimum ${min} characters required`)
          .required('Enter User Code')
          .transform((value) => (value ? value.toLowerCase() : value))
          .notOneOf(
            user.filter((user) => initialValue.UserID !== user.UserID).map((user) => user.LoginCode?.toLowerCase()),
            'User Code Already Exists'
          )
          .max(10, 'User Code is too Big'),
        LoginName: Yup.string()
          .min(2, ({ min }) => `Minimum ${min} characters required`)
          .required('Enter User Name')
          .max(50, ({ max }) => `Cannot exceed more than ${max} characters`),
        Password: Yup.string()
          .min(4, ({ min }) => `Minimum ${min} characters required`)
          .max(20, ({ max }) => `Cannot exceed more than ${max} characters`)
          .required('Enter Password'),
        EmailId: Yup.string()
          .max(50, ({ max }) => `Cannot exceed more than ${max} characters`)
          .email('Invalid email format')
          .required('Enter Password'),
        DesignationID: Yup.object().required('Select Designation'),
        SupervisorIds: Yup.array().nullable(),
      }),
    [user, initialValue]
  );

  async function UserSave(values) {
    console.log('values in edit', values);
    try {
      showLoading();
      const apiRoute = OpType === 'New' ? 'master/user/AddUser' : 'master/user/UpdateUser';
      const response = await axios.post(OpType === 'New' ? 'master/user/AddUser' : 'master/user/UpdateUser', {
        ...values,
        DesignationID: values.DesignationID === null ? 0 : values.DesignationID.Desg_id,
        SupervisorIds: values.SupervisorIds.map(user=>user.UserID),
        UserID: OpType === 'New' ? 0 : values.UserID,
        LoginUserId,
      });

      if (response.status === 200) {
        openSnackBar(
          `User ${OpType === 'New' ? 'Added' : 'Updated'} Successfully!`,
          OpType === 'New' ? 'success' : 'warning'
        );
      } else {
        openSnackBar('Something went wrong!', 'error');
      }
      getAllUser();
      // setFilterData(filterInitialValue);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
    handleClose();
  }

  const DeleteUser = async () => {
    try {
      showLoading();
      await axios.delete(`master/user/DeleteUser/${deleteUser}`);
      const newUser = user.filter((user) => user.UserID !== deleteUser);
      // setUsers(newUser);
      // setUserTableData(newUser);
      // setUserList(newUser.filter((user) => user.Active === 'yes'));
      openSnackBar('User Deleted Successfully!', 'warning');
      getAllUser();
      // setFilterData(filterInitialValue);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    handleCloseDelete();
    setDeleteUser(null);
    hideLoading();
  };

  const handleFilterDataChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };
  useEffect(() => {
    const newTableData = user.filter(
      (user) =>
        `${user.LoginCode} ${user.LoginName} ${user.EmailId} ${user.Designation} ${user.Supervisor}`
          .toLowerCase()
          .includes(filterData?.searchTerm?.toLowerCase()) &&
        user.Active?.toLowerCase()?.trim() === (filterData.Active ? 'yes' : 'no')
    );
    if (page > 0) setPage(0);
    setUserTableData(newTableData);
  }, [user, filterData]);

  // function handleUserFilterSearch(filtertext) {
  //   setUserFilterSearch(filtertext);
  //   const newDivsionTableData = user.filter((user) =>`${user.LoginCode} ${user.LoginName} ${user.EmailId} ${user.Designation} ${user.Supervisor}`.toLowerCase().includes(filtertext.toLowerCase()));
  //   setUserTableData(newDivsionTableData);
  // }

  const setEditValues = async (editData) => {
    try {
      showLoading();
      const DesignationObject = designationData.find(
        (desig) => Number(desig.Desg_id) === Number(editData.DesignationID)
      );
      const supervisorIdList = editData.SupervisorIds === '' ? [] : editData.SupervisorIds.split(',').map(id => id.trim());
      const supervisors = userList.filter(user => supervisorIdList.includes(String(user.UserID)));       
      const editvalue = {
        ...editData,
        DesignationID: designationData.find((desig) => Number(desig.Desg_id) === Number(editData.DesignationID)),
        SupervisorIds: supervisors,
      };
      setInitialValue(editvalue);
    } catch (e) {
      openSnackBar(e.response?.data || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
    setOpen(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setDeleteUser(null);
  };

  const handleClose = () => {
    setOpen(false);
    setOpType('New');
    setInitialValue(userInitailValue);
  };

  // pagination
  const { emptyRows, totalRows, currentPage } = useMemo(() => {
    const totalRows = userTableData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { emptyRows, totalRows, currentPage };
  }, [userTableData, page, rowsPerPage]);

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {/* table header */}
        <Grid justifyContent={'space-between'} alignItems={'center'}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              // borderRadius: 50,
              background: '#2A4759',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              USER MASTER
            </Typography>
          </Typography>
        </Grid>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={'space-between'}
          alignItems={'center'}
          spacing={2}
          my={3}
          px={3}
        >
          <TextField
            type="text"
            variant="outlined"
            user="secondary"
            label="Search"
            size="small"
            onChange={(e) => {
              handleFilterDataChange('searchTerm', e.target.value);
            }}
            value={filterData.searchTerm}
          />
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="subtitle2" fontWeight="bold">
              Active
            </Typography>

            {/* Toggle Switch with "Yes" / "No" */}
            <FormControlLabel
              control={
                <Switch
                  checked={filterData.Active}
                  onChange={(e) => {
                    handleFilterDataChange('Active', !filterData.Active);
                  }}
                  color="success"
                />
              }
              label={filterData.Active ? 'Yes' : 'No'}
            />
            <Divider orientation="vertical" flexItem />
            <Button
              variant="outlined"
              user="secondary"
              sx={{ boxShadow: 1 }}
              onClick={() => setOpen(!open)}
              startIcon={<PlaylistAddIcon />}
            >
              Add User
            </Button>
          </Stack>
        </Stack>
        <TableContainer sx={{ borderRadius: '7px', maxHeight: '450px' }} component={Paper} elevation={2}>
          <Table className="table-bordered" size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">S.No</StyledTableCell>
                <StyledTableCell align="left">User Name </StyledTableCell>
                <StyledTableCell align="left">User Code </StyledTableCell>
                <StyledTableCell align="left">E-Mail</StyledTableCell>
                <StyledTableCell align="left">Designation </StyledTableCell>
                <StyledTableCell align="left">Supervisor</StyledTableCell>
                <StyledTableCell align="center">Active</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? userTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : userTableData
              ).map((user, i) => (
                <TableRow key={user.UserID} hover>
                  <TableCell align="center">{user.SNo}</TableCell>
                  <TableCell align="left">{user.LoginName}</TableCell>
                  <TableCell align="left">{user.LoginCode}</TableCell>
                  <TableCell align="left">{user.EmailId}</TableCell>
                  <TableCell align="left">{user.Designation}</TableCell>
                  <TableCell align="left">{user.SupervisorNames}</TableCell>
                  <TableCell align="center">
                    <Chip
                      color={user.Active === 'yes' ? 'success' : 'error'}
                      label={user.Active === 'yes' ? 'Yes' : 'No'}
                      size="small"
                      icon={user.Active === 'yes' ? <CheckCircleOutlineIcon /> : <HighlightOffIcon />}
                    />
                  </TableCell>
                  <TableCell align="center" sx={{ padding: '0' }}>
                    <IconButton
                      aria-label="Edit"
                      onClick={() => {
                        setOpType('Edit');
                        setEditValues(user);
                      }}
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton
                      aria-label="Delete"
                      onClick={() => {
                        setDeleteUser(user.UserID);
                        setOpenDelete(true);
                      }}
                    >
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={11} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage} // Use the calculated currentPage value
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0); // Reset the page when rowsPerPage changes
          }}
          mt={2}
        />
        {/* add new popup form dialog box */}
        <Dialog maxWidth={'md'} open={open} onClose={handleClose} fullWidth>
          <Container component={Paper} elevation={2} sx={{ p: 2 }}>
            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
              <Typography variant="h5" textAlign={'left'} pl={2} fontWeight={600} color="primary">
                {OpType === 'New' ? 'Add' : 'Edit'} User
              </Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Stack>
            <Stack sx={{ p: 2 }}>
              <Formik
                validationSchema={userValidationSchema}
                initialValues={initialValue}
                onSubmit={async (values, { resetForm }) => {
                  await UserSave(values);
                  resetForm();
                }}
              >
                {({ submitForm, setFieldValue, touched, values, errors, handleChange, handleBlur, isSubmitting }) => (
                  <Form>
                    <Grid container justifyContent="center" spacing={2} rowSpacing={2} columnSpacing={2}>
                      <Grid item md={4} sm={7} xs={12}>
                        <TextField
                          required
                          fullWidth
                          size="small"
                          label="User Name"
                          type="text"
                          name="LoginName"
                          onBlur={handleBlur}
                          error={touched.LoginName && !!errors.LoginName}
                          helperText={touched.LoginName && errors.LoginName}
                          value={values.LoginName}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                      </Grid>
                      <Grid item md={4} sm={5} xs={12}>
                        <TextField
                          required
                          fullWidth
                          size="small"
                          label="User Code"
                          type="LoginCode"
                          name="LoginCode"
                          onBlur={handleBlur}
                          error={touched.LoginCode && !!errors.LoginCode}
                          helperText={touched.LoginCode && errors.LoginCode}
                          value={values.LoginCode}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                      </Grid>
                      <Grid item md={4} sm={5} xs={12}>
                        <TextField
                          required
                          fullWidth
                          size="small"
                          label="Password"
                          type="Password"
                          name="Password"
                          onBlur={handleBlur}
                          error={touched.Password && !!errors.Password}
                          helperText={touched.Password && errors.Password}
                          value={values.Password}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                      </Grid>
                      <Grid item sm={12} xs={12}>
                        <TextField
                          required
                          fullWidth
                          size="small"
                          label="E-Mail"
                          type="text"
                          name="EmailId"
                          onBlur={handleBlur}
                          error={touched.EmailId && !!errors.EmailId}
                          helperText={touched.EmailId && errors.EmailId}
                          value={values.EmailId}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item sm={6} xs={12}>
                        <Autocomplete
                          options={designationData}
                          getOptionLabel={(designationData) => designationData.Description?.trim() || ''}
                          isOptionEqualToValue={(value) =>
                            Number(value.Desg_id) === Number(values.DesignationID?.Desg_id)
                          }
                          renderOption={(props, designationData) => (
                            <li {...props} key={designationData.Desg_id}>
                              {designationData.Description}
                            </li>
                          )}
                          name="Designation"
                          value={values.DesignationID || null}
                          onChange={(event, value) => {
                            setFieldValue('DesignationID', value || null);
                          }}
                          size="small"
                          onBlur={handleBlur}
                          renderInput={(params) => (
                            <TextField
                              required
                              {...params}
                              label="Designation"
                              error={touched.DesignationID && !!errors.DesignationID}
                              helperText={touched.DesignationID && errors.DesignationID}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item sm={6} xs={12}>
                        <Autocomplete
                          multiple
                          options={
                            values.DesignationID?.Description?.trim() === 'Supervisor' ||
                            values.DesignationID?.Description?.trim() === 'Admin'
                              ? userList.filter(
                                  (user) =>
                                    (user.Designation === 'Supervisor' || user.Designation === 'Admin') &&
                                    user.UserID !== values.UserID
                                )
                              : userList.filter((user) => user.UserID !== values.UserID)
                          }
                          getOptionLabel={(user) => user.LoginName || ''}
                          isOptionEqualToValue={(value) => value.UserID === values.SupervisorIds?.UserID}
                          renderOption={(props, user) => (
                            <li {...props} key={user.UserID}>
                              {user.LoginName}
                            </li>
                          )}
                          name="SupervisorIds"
                          value={values.SupervisorIds || null}
                          onChange={(event, value) => {
                            setFieldValue('SupervisorIds', value || null);
                          }}
                          size="small"
                          onBlur={handleBlur}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Supervisor"
                              error={touched.SupervisorIds && !!errors.SupervisorIds}
                              helperText={touched.SupervisorIds && errors.SupervisorIds}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item sm={12} xs={12} ml={1}>
                        <FormControl size="small" fullWidth component="fieldset">
                          <FormLabel component="legend">Active Status</FormLabel>
                          <RadioGroup row value={values.Active?.trim()} name="Active" onChange={handleChange}>
                            <FormControlLabel value="yes" control={<Radio size="small" />} label="Yes" />
                            <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
                          </RadioGroup>
                          {errors.Active && (
                            <Typography
                              variant="caption"
                              color="error"
                              className={errors.Active ? 'shake-helper-text' : ''}
                            >
                              {errors.Active}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Stack direction="row" justifyContent="center" gap={2} sx={{ textAlign: 'center', mt: 3 }}>
                      {/* <Button
                        onClick={handleClose}
                        variant="contained"
                        color="error"
                        size="small"
                        sx={{ boxShadow: 1 }}
                      >
                        Cancel
                      </Button> */}

                      <Button
                        fullWidth
                        onClick={submitForm}
                        disabled={isSubmitting}
                        variant="contained"
                        color={OpType === 'New' ? 'primary' : 'warning'}
                        size="small"
                        sx={{ boxShadow: 1 }}
                      >
                        {OpType === 'New' ? 'Save' : 'Update'}
                      </Button>
                    </Stack>
                  </Form>
                )}
              </Formik>
            </Stack>
          </Container>
        </Dialog>
        {/* confirmation dialog */}
        <Dialog open={openDelete} onClose={handleCloseDelete} fullScreen={fullScreen} fullWidth maxWidth="xs">
          <DialogTitle id="responsive-dialog-title">Are you sure you want to delete?</DialogTitle>
          <DialogActions>
            <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
              Cancel
            </Button>
            <Button variant="contained" onClick={DeleteUser} color="error" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
};

export default User;
